import { render, staticRenderFns } from "./CandidateInterview.vue?vue&type=template&id=0dbbde90&scoped=true&"
import script from "./CandidateInterview.vue?vue&type=script&lang=js&"
export * from "./CandidateInterview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbbde90",
  null
  
)

export default component.exports